import React from 'react';
import { useBrand } from '../../app/config/brand';

const LoadingPage: React.FC = () => {
  const brand = useBrand();

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: brand.colors.bgLight }}>
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-t-transparent rounded-full animate-spin mx-auto mb-4" style={{ borderColor: brand.colors.primary, borderTopColor: 'transparent' }}></div>
        <p style={{ color: brand.colors.textLight }}>Loading...</p>
      </div>
    </div>
  );
};

export default LoadingPage;
